<template>
  <div id="common-settings">
    <v-card class="setup-card">
      <v-card-title>
        <span class="main_card_title">{{ $i18n.t('pages.system.common_settings.common_settings') }}</span>
      </v-card-title>
      <v-card-text style="padding: 0 16px 25px 16px">
        <div>
          <div>
            <v-subheader class="subheader">{{ $i18n.t('pages.system.common_settings.processing_method') }}</v-subheader>
            <v-radio-group v-model="processing_method" style="margin-top: 5px">
              <div style="display: flex; justify-content: space-around">
                <v-radio
                    :label="$i18n.t('pages.system.common_settings.image_mode')"
                    value="image"
                    style="margin-bottom: 0"
                    color="#207EA9"
                />
                <v-radio
                    :label="$i18n.t('pages.system.common_settings.video_mode')"
                    value="video"
                    style="margin-bottom: 0"
                    color="#207EA9"
                />
              </div>
            </v-radio-group>
          </div>
          <div>
            <v-subheader class="subheader">{{ $i18n.t('pages.system.common_settings.passage_detection_method') }}</v-subheader>
            <v-radio-group v-model="passage_detection_method" style="margin-top: 5px">
              <div style="display: flex; justify-content: space-around">
                <v-radio
                    :label="$i18n.t('pages.system.common_settings.vehicle_detected')"
                    value="vehicle_detected"
                    style="margin-bottom: 0"
                    color="#207EA9"
                />
                <v-radio
                    :label="$i18n.t('pages.system.common_settings.passage_detected')"
                    value="passage_detected"
                    style="margin-bottom: 0"
                    color="#207EA9"
                />
              </div>
            </v-radio-group>
          </div>
          <div>
            <v-subheader class="subheader">{{ $i18n.t('pages.system.common_settings.re_recognition_delay') }}</v-subheader>
            <div>
              <v-text-field
                v-model="re_recognition_delay"
                placeholder="PH: Введите число"
                class="rounded_8px height_56px settings_textfield"
                outlined
                @change="set_re_recognition_delay()"
              />
            </div>
          </div>
          <div style="margin-top: 15px;">
            <v-subheader class="subheader">{{ $i18n.t('pages.system.common_settings.license_plate_size_requirements') }} (%)</v-subheader>
            <div style="display: flex; justify-content: space-between; margin-top: 3px">
              <div style="max-width: 40%;">
                <div>{{ $i18n.t('pages.system.common_settings.minimum_size') }}</div>
                <v-text-field
                  v-model="min_plate_width"
                  placeholder="(0-100)"
                  class="rounded_8px height_56px settings_textfield"
                  outlined
                  @change="set_min_plate_width"
                />
              </div>
              <div style="max-width: 40%;">
                <div>{{ $i18n.t('pages.system.common_settings.maximum_size') }}</div>
                <v-text-field
                  v-model="max_plate_width"
                  placeholder="(0-100)"
                  class="rounded_8px height_56px settings_textfield"
                  outlined
                  @change="set_max_plate_width"
                />
              </div>
            </div>
          </div>
          <div style="margin-top: 15px;">
            <v-subheader class="subheader">{{ $i18n.t('pages.system.common_settings.autodiagnostics') }}</v-subheader>
            <v-checkbox
                v-model="memory_check_schedule"
                :label="memory_check_schedule_state_str"
            />
            <week-days-and-time-picker
              :watch_only="false"
              v-if="systemParams.memory_check_schedule_daily_start_time !== ''"
              :selected_weekdays_prop="systemParams.memory_check_schedule_weekdays"
              :start_time_in_mins_prop="systemParams.memory_check_schedule_daily_start_time"
              :end_time_in_mins_prop="systemParams.memory_check_schedule_daily_end_time"
              @change="set_memory_check_schedule_settings"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {common_funcs} from "@/mixins/common";
import {mapGetters} from "vuex";
import {i18n} from "../i18n";
import WeekDaysAndTimePicker from "@/custom_components/WeekDaysAndTimePicker";
// import {i18n} from "../i18n";

export default {
  name: "CommonSettings",
  components: {WeekDaysAndTimePicker},
  mixins: [common_funcs],
  data: function () {
    return {
      validation_rules: {
        min_plate_width: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            () => this.is_positive_integer(this.systemParams.min_plate_width)|| i18n.t('validation.set_number_of_days')
        ],
        max_plate_width: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            () => this.is_positive_integer(this.systemParams.max_plate_width)|| i18n.t('validation.set_number_of_days')
        ]
      }
    }
  },
  methods: {
    is_positive_integer: function (convertable_string) {
      return /^\d+$/.test(convertable_string);
    },
    set_min_plate_width () {
      this.set_system_params(
          {'min_plate_width': this.min_plate_width},
          'changes_saved'
      )
    },
    set_max_plate_width () {
      this.set_system_params(
          {'max_plate_width': this.max_plate_width},
          'changes_saved'
      )
    },
    set_re_recognition_delay () {
      this.set_system_params(
          {'re_recognition_delay': this.re_recognition_delay},
          'system_reboot_required'
      )
    },
    set_memory_check_schedule () {
      this.set_system_params(
          {'memory_check_shedule': this.memory_check_schedule},
          'changes_saved'
      )
    },
    set_memory_check_schedule_settings (params) {
      console.log(params)
      this.set_system_params(
          {
            'memory_check_schedule_weekdays': params.selected_weekdays,
            'memory_check_schedule_daily_start_time': params.start_time_in_mins,
            'memory_check_schedule_daily_end_time': params.end_time_in_mins,
          },
          'changes_saved'
      )
    }
  },
  computed: {
    processing_method: {
      get () {
        return this.systemParams.processing_method
      },
      set (value) {
        this.set_system_params({processing_method: value}, 'system_reboot_required')
      }
    },
    passage_detection_method: {
      get () {
        return this.systemParams.passage_detection_method
      },
      set (value) {
        this.set_system_params({passage_detection_method: value}, 'system_reboot_required')
      }
    },
    re_recognition_delay: {
      get () {
        return this.systemParams.re_recognition_delay
      },
      set (value) {
        // this.set_system_params({re_recognition_delay: value}, 'system_reboot_required')
        this.updateSystemParams({
          re_recognition_delay: value,
        })
      }
    },
    min_plate_width: {
      get () {
        return this.systemParams.min_plate_width
      },
      set (value) {
        this.updateSystemParams({ min_plate_width: value })
      }
    },
    max_plate_width: {
      get () {
        return this.systemParams.max_plate_width
      },
      set (value) {
        this.updateSystemParams({ max_plate_width: value })
      }
    },
    memory_check_schedule: {
      get () {
        return this.systemParams.memory_check_schedule
      },
      set (value) {
        this.set_system_params({memory_check_schedule: value}, 'changes_saved')
      }
    },
    memory_check_schedule_state_str () {
      if (this.memory_check_schedule) return i18n.t('pages.system.common_settings.autodiagnostics_on')
      else return i18n.t('pages.system.common_settings.autodiagnostics_off')
    },
    ...mapGetters(['systemParams'])
  }
}
</script>

<style>
.setup-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15) !important;
  border-radius: 8px;
  elevation: 0;
}
</style>